import { Shield } from "lucide-react";

export function ApiKeySecurityNotice() {
    return (
        <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-900 rounded p-4 select-none">
            <div className="flex gap-3">
                <Shield className="size-5 text-amber-600 shrink-0 mt-0.5" />
                <div>
                    <h4 className="font-medium text-amber-900 dark:text-amber-100 mb-1">
                        Keep Your Keys Secure
                    </h4>
                    <p className="text-sm text-amber-800 dark:text-amber-200">
                        Never share your API keys or commit them to version
                        control. Use environment variables to store keys
                        securely.
                    </p>
                </div>
            </div>
        </div>
    );
}
